module.exports = __webpack_public_path__ + "static/media/wordmark_white.2e55bf03.svg";